enum Genders {
    MALE = 'male',
    FEMALE = 'female',
}

export default Genders
